import ajax from './ajax';

/* eslint-disable import/prefer-default-export */
export function requestAccountList() {
  return ajax('/resources/list-account/');
}

export function createAccount(data) {
  return ajax('/resources/add-account/', { method: 'POST', data });
}

export function deleteAccount(id) {
  return ajax(`/resources/delete-account/${id}`, { method: 'DELETE' });
}

export function deleteBrand(id) {
  return ajax(`/resources/delete-brand/`, {  method: 'POST', data: {brandId: id }  });
}
